import axiosInstance from "./api";
import TokenService from "./token.service";
import { logoutUser, refreshToken } from "../actions/authSlice";

const setup = (store) => {
  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error, token = null) => {
    failedQueue.forEach(({ resolve, reject }) => {
      if (error) reject(error);
      else resolve(token);
    });
    failedQueue = [];
  };

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const { dispatch } = store;
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      if (
        originalConfig.url !== "/auth/token/obtain/" &&
        originalConfig.url !== "/auth/token/refresh/" &&
        err.response
      ) {
        if (err.response.status === 401) {
          // If a refresh is already in progress, queue this request
          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            }).then((token) => {
              originalConfig.headers["Authorization"] = "Bearer " + token;
              return axiosInstance(originalConfig);
            });
          }

          isRefreshing = true;

          try {
            const rs = await axiosInstance.post("/auth/token/refresh/", {
              refresh: TokenService.getLocalRefreshToken(),
            });

            const { access, refresh } = rs.data;

            if (access && refresh) {
              TokenService.updateLocalAccessToken(access);
              TokenService.updateLocalRefreshToken(refresh);

              // Fetch user info — failure here should not block retry or cause logout
              try {
                const userTypeResponse = await axiosInstance.get("/user/type/");
                const userInfos = userTypeResponse.data;
                localStorage.setItem(
                  "userLM",
                  JSON.stringify({ ...rs.data, ...userInfos })
                );
              } catch (_userTypeError) {
                // Non-critical: user info will be stale but tokens are valid
              }

              dispatch(refreshToken(access));
              processQueue(null, access);

              originalConfig.headers["Authorization"] = "Bearer " + access;
              return axiosInstance(originalConfig);
            } else {
              TokenService.removeUser();
              processQueue(new Error("Invalid token response"), null);
              dispatch(logoutUser());
              return Promise.reject(err);
            }
          } catch (_error) {
            processQueue(_error, null);
            dispatch(logoutUser());
            return Promise.reject(_error);
          } finally {
            isRefreshing = false;
          }
        }
      }
      return Promise.reject(err);
    }
  );
};

export default setup;
